export { default, type OtherEventsSectionProps } from './OtherEventsSection';
